
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[uid]",
      function () {
        return require("private-next-pages/blog/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[uid]"])
      });
    }
  